export const LOCALE_OUT_OF_STOCK = 'Producto agotado'
export const LOCALE_PRICE_TAXES_ADVICE = '*precio con I.V.A incluido'
